/**********************
 * FETCHING GROUP TAGS
 *********************/
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import { TreeSelect, ConfigProvider } from "antd"
import { getAvailableTags } from "helpers/backend_helper"
const { SHOW_ALL } = TreeSelect
import PubSub from "pubsub-js"

const TagsTree = props => {
  const [loading, setLoading] = useState(false)
  const [treeData, setTreeData] = useState(props.data)
  const [selectedValue, setSelectedValue] = useState(undefined)

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()

    // Parent component not providing tree data, load here
    if (props.loadData) {
      getTags()
    }

    // Refresh tags
    const token = PubSub.subscribe("tags-refresh", (event, data) => {
      if (props.loadData) getTags()
    })

    return () => {
      abortRef.current.abort()
      PubSub.unsubscribe(token)
    }
  }, [])

  // Selection from props
  useEffect(() => {
    if (props.data) {
      setTreeData(props.data)
    }
  }, [props.data])

  // Selection from props
  useEffect(() => {
    if (props.selected) {
      //console.log("Selected props: ", props.selected)
      setSelectedValue(props.selected)
    } else if (props.multiple) {
      setSelectedValue([])
    } else {
      setSelectedValue(undefined)
    }
  }, [props.selected])

  // Load tags
  const getTags = () => {
    setLoading(true)
    getAvailableTags(abortRef.current)
      .then(result => {
        if (result.statusCode == 200) {
          result.tags.sort((a, b) => (a.title > b.title ? 1 : -1))
          for (const tag of result.tags) {
            tag.children.sort((a, b) => (a.title > b.title ? 1 : -1))
          }
          setTreeData(result.tags)
          //console.log("Tags: ", result.tags)
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // Tree selection changed
  const onChange = (newValue, title) => {
    // console.log("onChange ", newValue, title)
    setSelectedValue(newValue)
    if (props.selectionChanged) {
      props.selectionChanged(newValue)
    }
    if (props.selectedTagTitles) {
      props.selectedTagTitles(title)
    }
  }

  // Empty list render
  const customizeRenderEmpty = () => (
    <div className="mt-3" style={{ textAlign: "center" }}>
      {loading ? (
        <p>{props.t("Loading")}</p>
      ) : (
        <p>{props.t("No tags found")}</p>
      )}
    </div>
  )

  return (
    <>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <TreeSelect
          popupClassName="custom-scrollbar"
          placement="bottomLeft"
          loading={loading}
          style={{ width: "100%" }}
          value={selectedValue}
          virtual={false}
          treeData={treeData}
          placeholder={
            !props.multiple ? props.t("Select tag") : props.t("Select tags")
          }
          allowClear={true}
          treeDefaultExpandAll={props.expanded != null ? props.expanded : false}
          showCheckedStrategy={SHOW_ALL}
          showSearch={true}
          treeNodeFilterProp={"title"}
          multiple={props.multiple != null ? props.multiple : true}
          onChange={onChange}
          onDropdownVisibleChange={props.onDropdownVisibleChange}
          onSelect={props.onSelect}
        />
      </ConfigProvider>
    </>
  )
}

TagsTree.propTypes = {
  t: PropTypes.any,
  data: PropTypes.array,
  selected: PropTypes.any,
  selectionChanged: PropTypes.func,
  loadData: PropTypes.bool,
  multiple: PropTypes.bool,
  expanded: PropTypes.bool,
  selectedTagTitles: PropTypes.func,
  onDropdownVisibleChange: PropTypes.any,
  onSelect: PropTypes.any,
}

export default withTranslation()(TagsTree)
